import { FormikProps } from "formik";
import ICSwitch from "../form/ICSwitch";

interface ICustomFormikSwitch<T> extends FormikProps<T> {
  name: keyof T;
  placeholder: string;
  checkedValue: string | number | boolean;
  unCheckedValue: string | number | boolean;
  containerClassName?: string;
  disabled?: boolean;
  required?: boolean;
}

const ICFormikSwitch = <T extends Object>(props: ICustomFormikSwitch<T>) => {
  const { values, setFieldValue } = props;
  const {
    name,
    placeholder,
    containerClassName,
    checkedValue,
    unCheckedValue,
    disabled,
    required,
  } = props;
  const fieldName = props.name as string;

  const handleSwitchChange = (value: boolean) => {
    if (!disabled) {
      const newValue = value ? checkedValue : unCheckedValue;
      setFieldValue(fieldName, newValue);
    }
  };

  return (
    <ICSwitch
      placeholder={placeholder}
      containerClassName={containerClassName}
      required={required}
      onChange={handleSwitchChange}
      disabled={disabled}
      checked={values[name] === checkedValue}
    />
  );
};

export default ICFormikSwitch;
